import createAxiosInstance from './Axios';

export const callGetValidationDni = (rut, serie, reCaptchaToken, baseURL) => {
  const axiosInstance = createAxiosInstance(baseURL);

  return axiosInstance({
    url: `/form/validation/dni/${rut}/${serie}`,
    method: 'get',
    headers: {
      reCaptchaToken: reCaptchaToken,
    },
  });
};
